import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PatchIncident(idIncident) {
  try {
    const apiConfig = await getApiConfig();

    const req = `${apiConfig.BASE_URL}incident/${idIncident}`;

      const userPatch = {
        incidentState: "3469a709-850d-4788-b298-0461b4d46a74",
      };
  
    const response = await axios.patch(req, userPatch, apiConfig.HEADERS_CONFIG,{
      });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
